"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PillSize = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _icon = _interopRequireDefault(require("../icon"));

var _indexModule = _interopRequireDefault(require("./index.module.scss"));

var PillSize;
exports.PillSize = PillSize;

(function (PillSize) {
  PillSize["Primary"] = "primary";
  PillSize["secondary"] = "secondary";
})(PillSize || (exports.PillSize = PillSize = {}));

var Pill = function Pill(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? PillSize.Primary : _ref$type,
      label = _ref.label,
      name = _ref.name,
      children = _ref.children,
      className = _ref.className,
      onRemove = _ref.onRemove,
      dataTestId = _ref.dataTestId;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)(_indexModule.default.pillWrapper, className)
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": dataTestId,
    className: (0, _classnames.default)(_indexModule.default.pill, _indexModule.default[type], (0, _defineProperty2.default)({}, _indexModule.default.removable, !!onRemove))
  }, label || children, onRemove && /*#__PURE__*/_react.default.createElement("button", {
    className: _indexModule.default.removeIconWrapper,
    "aria-label": "remove ".concat(label || name),
    onClick: onRemove
  }, /*#__PURE__*/_react.default.createElement(_icon.default, {
    type: "cross",
    className: _indexModule.default.removeIcon,
    size: "small"
  }))));
};

Pill.propTypes = {
  type: _propTypes.default.oneOf(['primary', 'secondary']),
  label: _propTypes.default.string,
  name: _propTypes.default.string,
  className: _propTypes.default.string,
  onRemove: _propTypes.default.func,
  dataTestId: _propTypes.default.string
};
Pill.defaultProps = {
  type: PillSize.Primary
};
var _default = Pill;
exports.default = _default;